<template>
  <v-sheet>
    <v-container class="wrap-container">
      <v-row class="pa-0 ma-0">
        <v-col cols="12" class="px-1">
          <masonry
            :gutter="{ default: '20px', 700: '8px' }"
            :cols="{ default: 3, 1440: 3, 767: 2 }"
          >
            <v-card
              v-for="(data, index) in fetch_list"
              :key="index"
              class="infinite-wrapper elevation-0"
              @click="DETAIL_VIEW_FUNC(data)"
            >
              <v-row class="pa-0 ma-0 mb-5">
                <v-col cols="12" class="pa-3">
                  <v-list-item class="pa-0 ma-0 text-subtitle-2 navy--text">
                    {{ data.SUBJECT }}
                  </v-list-item>
                  <v-divider class="ma-0 pa-0"></v-divider>
                  <v-card class="pa-1 px-3 ma-0 mt-3" elevation="5" tile>
                    <v-img
                      :src="
                        'https://images.emons.co.kr/brand/upload_files' +
                        data.DELEGATE_IMG_PATH +
                        data.DELEGATE_IMG_SAVE
                      "
                      class="upload_img mt-2"
                    ></v-img>
                    <v-card-actions>
                      <v-row align="center" justify="end">
                        <span class="mr-3 grey--text">
                          <small>{{ data.DIVISION }}</small>
                        </span>
                      </v-row>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </masonry>
        </v-col>
      </v-row>
      <infinite-loading
        :identifier="infiniteId"
        @infinite="FETCH_DATA"
        spinner="waveDots"
        force-use-infinite-wrapper=".infinite-wrapper"
        class="white--text"
      >
        <div slot="no-more">
          총 {{ GE_PUT_FETCH_LIST_INFO_DATA.total_count }}개 검색 결과
        </div>
        <div slot="no-results">검색 결과 없음</div>
      </infinite-loading>
    </v-container>
  </v-sheet>
</template>

<script>
import { mapActions } from "vuex";
import InfiniteLoading from "vue-infinite-loading";

import CommonMixin from "@/config/commonFunc";

export default {
  name: "CatalogList",
  components: {
    InfiniteLoading,
  },
  mixins: [CommonMixin],
  computed: {
    //
  },
  data: () => ({
    model: null,
    app_type: "homepage",
    page_type: "ecatalog",
    action: "catalog_list",
    include_file: "list",
    array_name: "data_list",
    page: 1,
    page_offset: 10,
    division: "e-catalog",
    infiniteId: +new Date(),
    fetch_list: [],
  }),
  created() {
    // this.FETCH_DATA();
  },
  methods: {
    ...mapActions({
      AC_CUST_VIEW_DATA: "fetchAction/AC_CUST_VIEW_DATA",
    }),
    RELOAD_FUNC: function () {
      this.fetch_list = [];
      this.page = 1;
      this.infiniteId += 1;
    },
    FETCH_DATA: function ($state) {
      const payload = {
        array_name: this.array_name,
        app_type: this.app_type,
        include_file: this.include_file,
        page_type: this.page_type,
        action: this.action,
        page_num: this.page,
        page_offset: this.page_offset,
        division: this.division,
      };
      this.AC_PUT_FETCH_DATA(payload).then((res) => {
        if (res.data[this.array_name].length) {
          this.page += 1;
          this.fetch_list.push(...res.data[this.array_name]);
          $state.loaded();
          if (res.data[this.array_name].length / this.page_offset < 1) {
            $state.complete();
          }
        } else {
          $state.complete();
        }
      });
    },
    DETAIL_VIEW_FUNC: function (data) {
      this.$MOVE_FUNC("CatalogView", {
        seq: data.BOARD_SEQ,
        subject: data.SUBJECT,
      });
    },
  },
  watch: {
    //
  },
};
</script>
<style>
.wrap-container {
  max-width: 1440px;
  margin: 0 auto;
  overflow: hidden;
}
</style>
